import Vue    from 'vue';
import App    from './App.vue';
import router from './router';
import store  from './store';

import 'buefy/dist/buefy.css';
import Buefy from 'buefy';
import './styles/buefy.scss';
import '@mdi/font/css/materialdesignicons.css';
import 'currency-flags/dist/currency-flags.css';

import { datadogRum, datadogLogs } from './datadog';

import httpClientCMS     from './services/httpClientCMS';
import httpClientCMSPost     from './services/httpClientCMSPost';
import httpClient from './services/httpClient';

Vue.prototype.$httpClientCMS     = httpClientCMS;
Vue.prototype.$httpClientCMSPost     = httpClientCMSPost;
Vue.prototype.$httpClient = httpClient;
Vue.prototype.$awsCdnHostname = process.env.VUE_APP_AWS_S3_CDN_HOSTNAME

Vue.use(Buefy);

// Initiate dataDogRum
Vue.prototype.$datadogRum = datadogRum

// Initiate datadogLogs
Vue.prototype.$datadogLogs = datadogLogs

Vue.config.productionTip = false

console.log('App version', process.env.VUE_APP_VERSION)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
